export default {"src":"/_next/static/media/flower.0cf3a019.svg","height":228,"width":229,"blurWidth":0,"blurHeight":0};